import React, { useEffect, useState, useContext, useLayoutEffect, useCallback } from 'react'
import '../css/sb-admin-2.min.css'
import '../css/sb-admin-2.css'


import $ from 'jquery';
import { AppColors } from '../css/AppColors';
import { apiRequest } from '../utils/apiCalls';
import { Modal, Button } from 'react-bootstrap';
import Sidebar from '../Components/Sidebar';
import Topbar from '../Components/Topbar';
import { Context } from '../Context/DataContext';
import { FaClipboardList, FaPencilAlt, FaTrash, FaFileInvoiceDollar } from 'react-icons/fa'
import { Link } from 'react-router-dom';
import { setDefaultLocale } from 'react-datepicker';
import { useHistory } from 'react-router-dom';

import refreshIcon from '../img/refreshIcon.svg';


const useForceUpdate = () => {
    const [, updateState] = React.useState();
    return useCallback(() => updateState({}), []);
}


const ViewExpiries = (props) => {



    const forceUpdate = useForceUpdate()
    const history = useHistory();
    const { state, setCustomersGlobal, setStoreData, setExpiriesGlobal } = useContext(Context)
    const [loading, setLoading] = useState(false)
    const [expiries, setExpiries] = useState(state?.expiries ? state.expiries : [])
    const [val, setVal] = useState(0)
    const [delCustModal, setDelCustModal] = useState(false)
    const [delCustId, setDelCustId] = useState('')
    const [delExpParent, setDelExpParent] = useState('')

    function getexpiries() {

        setLoading(true)
        const st_id = state.storeData.st_id
        apiRequest({ st_id: st_id }, 'viewExpiries')
            .then(data => {
                setLoading(false)
                if (data.status == 1) {
                    setExpiries(data.data)
                    // setCustomersGlobal(data.data)
                }

            })
            .catch(err => {
                setLoading(false)
                console.log(err)
            })
    }


    function delCust() {
        setLoading(true)
        const reqObj = {
            exp_id: delCustId,
            parent: delExpParent,
            st_id: state.storeData.st_id
        }
        console.log(reqObj)
        apiRequest(reqObj, 'deleteExpiry')
            .then(data => {
                setLoading(false)
                console.log(data)
                if (data.status == '1') {
                    setLoading(false)
                    // alert('Manufactur Deleted')
                    setExpiries(data.expiries);
                    // setExpiriesGlobal(data.expiries)
                }
                else alert(data.error)
            })
            .catch(err => {
                setLoading(false)
                alert('Internet Error')
            })
    }







    useEffect(() => {
        getexpiries()
    }, [])


    useEffect(() => {
        $(document).ready(function () {
            // $('#dataTable').DataTable();
            {
                $('#dataTable').DataTable({
                    searching: false, paging: false, info: false,
                    language: {
                        emptyTable: "No expiry found.",
                        zeroRecords: "No expiry matches your search."
                    },
                    "order": [[0, "asc"]]
                });
            }
        });
    }, [loading])


    return (
        <div id="page-top">

            <div id="wrapper" >
                <Sidebar />
                <div id="content-wrapper" class="d-flex flex-column">
                    <div id="content">
                        <Topbar />


                        <div className="container-fluid" >


                            <Modal
                                show={delCustModal}
                                onHide={() => setDelCustModal(false)}
                            >
                                <Modal.Header>
                                    <Modal.Title style={{ fontSize: 18, textAlign: 'center', alignSelf: 'center', fontFamily: 'PSBo' }} >All the childrens will be deleted for this expiry.</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <p style={{ textAlign: 'center' }}>Are you sure you want to delete this expiry?</p>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button
                                        style={{ fontFamily: 'PMe' }}
                                        variant="secondary" onClick={() => {
                                            setDelCustId('')
                                            setDelCustModal(false)
                                        }}>No</Button>
                                    <Button
                                        style={{ fontFamily: 'PMe' }}
                                        variant="danger" onClick={() => {
                                            setDelCustModal(false)
                                            delCust()
                                        }}>Yes</Button>
                                </Modal.Footer>


                            </Modal>
                            <Modal

                                show={loading}
                            // onHide={() => setLoading(false)}
                            >

                                <Modal.Body class="text-center" >
                                    <div
                                        class="text-center"
                                        class="spinner-border text-center" style={{ margin: 10, color: AppColors.primary }} role="status"></div>
                                </Modal.Body>

                            </Modal>

                            {/* Page Heading */}
                            <div style={{ width: "100%", height: 65, }}>
                                <div style={{ float: "left", width: "50%" }}>
                                    <h1
                                        style={{ fontFamily: 'RSBo' }}
                                        className="h3 mb-2 text-gray-800 ">View Product Age</h1>
                                    <br />
                                </div>

                                <div style={{ float: "right", display: 'flex', flexDirection: 'column', marginTop: -20 }}>
                                    {/* <Button
                                        onClick={() => getexpiries()}
                                        className="rBBtn"
                                        style={{ width: 50, background: 'none', borderWidth: 0, float: 'right', alignSelf: 'center', marginRight: 10, borderColor: 'white' }}
                                    >
                                        <img src={refreshIcon} style={{ width: 20, color: 'red', }} />
                                    </Button> */}
                                    <Button
                                        className="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm"
                                        style={{ color: 'white', backgroundColor: AppColors.primary, borderWidth: 0, marginTop: 10, fontFamily: 'RBo', }}

                                    >
                                        <Link
                                            style={{ color: 'white', textDecorationLine: 'none', }}
                                            to="/addProdExpiry">
                                            Add Product Age
                                        </Link>
                                    </Button>
                                </div>


                            </div>

                            {/* DataTales Example */}
                            <div className="card shadow mb-4" style={{ width: "100%" }} >
                                <div className="card-body">
                                    {
                                        !loading &&

                                        <div className="table-responsive">
                                            {/* table class="table table-bordered dt-responsive" id="dataTable" width="100%" cellspacing="0" */}

                                            <table
                                                id="dataTable"
                                                className="table table-striped table-bordered dt-responsive"
                                                style={{ width: "100%" }}
                                                cellSpacing={0}
                                            >
                                                <thead>
                                                    <tr>
                                                        <th hidden={true} className="d-none" >Sort Order</th>
                                                        <th className="tRow" >Title</th>
                                                        <th className="tRow">Notification (days)</th>
                                                        <th className="tRow">Parent</th>
                                                        <th className="tRow">Status</th>
                                                        <th className="tRow"> Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>

                                                    {
                                                        expiries?.map((v) => {
                                                            return (
                                                                <tr>
                                                                    <td hidden={true} className="d-none">
                                                                        <nobr>{v.sort_order}</nobr>
                                                                    </td>
                                                                    <td className="tData">
                                                                        <nobr>{v.exp_title}</nobr>
                                                                    </td>
                                                                    <td className="tData">
                                                                        <nobr>{v.exp_no_days > 0 ? v.exp_no_days : "-"}</nobr>
                                                                    </td>
                                                                    <td className="tData">
                                                                        <nobr>{v.parent == '0' ? "NO PARENT" : v.parent_title} </nobr>
                                                                    </td>
                                                                    <td className="tData">
                                                                        <nobr>{v.status}</nobr>
                                                                    </td>



                                                                    <td>
                                                                        <nobr>


                                                                            <Link to={{
                                                                                pathname: "/editProdExpiries",
                                                                                state: v

                                                                            }} className="btn" style={{ backgroundColor: '#54C2BB' }} >
                                                                                <FaPencilAlt color="white" />
                                                                            </Link>{" "}

                                                                            {/* <Button
                                                                                onClick={() => {
                                                                                    setDelCustId(v.exp_id)
                                                                                    setDelExpParent(v.parent)
                                                                                    setDelCustModal(true)
                                                                                }}
                                                                                className="btn btn-danger">
                                                                                <FaTrash color="white" />
                                                                            </Button> */}
                                                                        </nobr>
                                                                    </td>
                                                                </tr>
                                                            )
                                                        })
                                                    }


                                                </tbody>
                                            </table>

                                        </div>
                                    }

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >


    )
}



export default ViewExpiries
